module.exports = {
	"ha": "vcha",
	"id": 2.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for Vancouver Coastal Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					4308.688918530088,
					4296.626187825276,
					4495.297263743489,
					5500.209554105308,
					6645.359143903418,
					7623.680413348745,
					8459.076007035923,
					8731.340218886675,
					{
						"y": 9044.73378883589,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					7336.148819699669,
					7558.690200330011,
					7670.625285477318,
					9478.085981043829,
					12115.303787418858,
					14074.99382045401,
					15794.121357386148,
					16504.34280080907,
					{
						"y": 16342.766913640227,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					4521.288655119253,
					4441.142200982793,
					4655.287704146975,
					6216.6750216469945,
					8949.423144155693,
					10847.84707129448,
					12002.742246838297,
					12303.108745024298,
					{
						"y": 11747.111894511218,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1842.3596343450522,
					1909.6665759866835,
					2189.5249440379102,
					4165.0140863811175,
					7251.769786033739,
					10738.195040044455,
					12234.04752120148,
					12243.407448658667,
					{
						"y": 11590.560819896977,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_2_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_2_3.json
// module id = 286
// module chunks = 0